import request from '@/utils/request'
export function Yuyanlies(data) {//我的积分记录
 return request({
    url:"/language/list",
	// url:'/video/page',
    method: 'post',
	data:data
  })
}

export function Resourcewb(data) {//我的积分记录
 return request({
    url:"/resource/list",
	method: 'get'
  })
}
export function Guangaoty(data) {//类型显示广告
 return request({
    url:`/banner/RESOURCE_MIDDLE`,
    method: 'get'
  })
}
export function Guojias(data) {//国家筛选
 return request({
    url:`/language/country`,
	method: 'post',
	data:data
  })
}
export function  videotype(data) {//视频类型
	return request({
		url:'/video/type',
		method: 'get',
	})
}
export function videocptype(data) {//产品类型
	return request({
		url:'/datadict/PRODUCT',
		method: 'get',
	})
}

export function  videoxq(data) {//视频详情
	return request({
		url:`/video/info/${data}`,
		method: 'get',
	})
}
export function  videolist(data) {//不分页查视频列
	return request({
		url:`/video/list/${data}`,
		method: 'get',
	})
}

export function  videohot(data) {//热门视频
	return request({
		url:'/video/hot',
		method: 'post',
		data:data
	})
}
export function  indexvideo(data) {//不分页视频
	return request({
		url:'/video/home/',
		method: 'get'
	})
}
export function Tyvideolie(data) {
	return request({
		url:'/video/page',
		// url: `/video/page?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data:data
	})
}
export function Tyvideolie2(data) {
	return request({
		url:'/video/page',
		// url: `/video/page?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data:data
	})
}

export function Reblogtop(data) {//resource页面BLOG
	return request({
		url:'/measure/recommend',
		method: 'get'
	})
}
export function Rewebinartop(data) {//resource页面webinar
	return request({
		url:'/seminar/recommend',
		method: 'get'
	})
}
export function videotop(data) {//resource页面webinar
	return request({
		url:'/video/recommend',
		method: 'get'
	})
}
export function Rebloghot(data) {//resource页面BLOG
	return request({
		url:'/resource/hot',
		method: 'get'
	})
}
export function Blogtop(data) {//resource页面BLOG
	return request({
		url:'/measure/hot',
		method: 'get'
	})
}
export function Youjiandingyue(data) {//邮件订阅
	return request({
		url:'/emailSubscript',
		method: 'post',
		data:data
	})
}
// ==========================================playlists
// 视频合集playlists
export function Playlist(data) {
	return request({
		url:'/videoCollection/page',
		method: 'post',
		data:data
	})
}
// 视频合集playlists plus+
export function Playlistplues(data) {
	return request({
		url:'/videoCollection/recommend',
		method: 'get'
	})
}
export function Playlistxq(data) {
	return request({
		url: `/videoCollection/${data}`,
		method: 'get'
	})
}

// ==========================================playlists
// webinar===========================================
export function Webinarxq(data) {
	return request({
		url: `/seminar/InfoId/${data}`,
		method: 'get'
	})
}
export function Webinarfl(data) {
	return request({
		url: `/datadict/SEMINAR_TYPE`,
		method: 'get'
	})
}
export function Webinars(data) {
	return request({
		url:'/seminar/page',
		method: 'post',
		data:data
	})
}

export function Webinarindex(data) {//头部Webinars
	return request({
		url:'/seminar/home',
		method: 'get'
	})
}
export function Webinajoin(data) {//Webinars报名参会
	return request({
		url:`/seminarRegister/addWebinar/${data.id}`,
		method: 'get'
	})
}
export function zoomjoin(data) {//zoomjoin报名参会
	return request({
		url:`/seminar/addUser/${data.seminarId}`,
		method: 'post',
		// data:new URLSearchParams(data).toString()
	})
}
// webinar===========================================
